module.exports = __webpack_public_path__ + "img/first-avater-1@2x.4a5e17b.png";